import { useEffect } from 'react';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import Constants from '../../Constants';
import { ApplicationState } from '../../store';

const OrganizationContainer = () => {
    const organizationData = useSelector((state: ApplicationState) => state.appOrganization.data);

    const updateDocumentTitle = (): void => {
        if (!organizationData.organization) {
            return;
        }

        if (organizationData.isWhiteLabel) {
            document.title = organizationData.organization.name;
            return;
        }

        if (organizationData.isTotvs) {
            document.title = Constants.APP_TOTVS_TITLE;
            return;
        }

        document.title = Constants.APP_TITLE;
    };

    useEffect(updateDocumentTitle, [organizationData]);

    return null;
};

export { OrganizationContainer };
